// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"_1H6j747n","tableWrapper":"_2dje0pDc","table":"o7rmsLjD"};